// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"65":"871a62a8","454":"ebbd218e"}[chunkId] + ".css";
};